var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 21.715,
    height: 21.715,
    rx: 3.09,
    stroke: "url(#paint0_linear_7903_98949)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8309 8.70358C15.5208 8.88306 15.2108 9.06255 14.9008 9.24204C14.6071 9.42152 14.2971 9.60101 13.9707 9.7805C13.8402 9.55206 13.7096 9.32362 13.5791 9.09518C13.4486 8.86675 13.318 8.64647 13.1875 8.43434C13.5138 8.25486 13.832 8.07537 14.142 7.89588C14.4521 7.7164 14.7621 7.54507 15.0721 7.3819C14.7621 7.20241 14.4521 7.01476 14.142 6.81896C13.832 6.62316 13.522 6.43551 13.212 6.25602C13.3262 6.0439 13.4404 5.83994 13.5546 5.64414C13.6852 5.43201 13.8075 5.21989 13.9218 5.00777L15.8309 6.10917V3.85742H17.3973C17.3973 4.23271 17.3891 4.608 17.3728 4.9833C17.3728 5.35859 17.3728 5.73388 17.3728 6.10917C17.6992 5.92968 18.0255 5.7502 18.3518 5.57071C18.6782 5.3749 18.9964 5.19542 19.3064 5.03225C19.4206 5.24437 19.543 5.45649 19.6735 5.66861C19.804 5.86442 19.9264 6.06838 20.0406 6.2805C19.7143 6.45999 19.388 6.64763 19.0616 6.84344C18.7353 7.03924 18.4089 7.22689 18.0826 7.40637L19.9917 8.50777C19.8612 8.71989 19.7306 8.94017 19.6001 9.16861C19.4696 9.39705 19.339 9.62549 19.2085 9.85393C18.8985 9.67444 18.5884 9.48679 18.2784 9.29099C17.9684 9.09518 17.6502 8.90754 17.3239 8.72805C17.3239 9.08703 17.3157 9.446 17.2994 9.80497C17.2994 10.1476 17.2994 10.4984 17.2994 10.8574H15.8309V8.70358Z",
    fill: "url(#paint1_linear_7903_98949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7903_98949",
    x1: 15.5428,
    y1: 24.7103,
    x2: 8.17219,
    y2: -0.995391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDAD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FB832E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FA7321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F6692F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E84A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E03675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DD2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B43D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4D60D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4264DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7903_98949",
    x1: 17.679,
    y1: 11.1512,
    x2: 15.4641,
    y2: 3.5885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDAD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FB832E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FA7321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F6692F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E84A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E03675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DD2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B43D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4D60D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4264DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.15cb0e9a101d84e3695890f1cb38c082.svg";
export { ForwardRef as ReactComponent };